var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 112,
    height: 112,
    rx: 6,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.37 38.6897L58.4578 38.7776H58.5821H91.4735C92.6064 38.7776 93.6928 39.2276 94.4939 40.0287C95.2949 40.8297 95.745 41.9162 95.745 43.049V55.2395C95.745 55.5641 95.616 55.8753 95.3865 56.1049C95.157 56.3344 94.8457 56.4633 94.5212 56.4633C94.1966 56.4633 93.8853 56.3344 93.6558 56.1049C93.4263 55.8753 93.2973 55.5641 93.2973 55.2395V43.049C93.2973 42.5653 93.1052 42.1014 92.7632 41.7594C92.4211 41.4174 91.9572 41.2252 91.4735 41.2252H22.9021H22.6021V41.5252V85.9481C22.6021 86.3693 22.7691 86.7734 23.0666 87.0717C23.364 87.37 23.7676 87.5382 24.1888 87.5395H24.1897H55.1154C55.44 87.5395 55.7513 87.6684 55.9808 87.8979C56.2103 88.1274 56.3393 88.4387 56.3393 88.7633C56.3393 89.0879 56.2103 89.3992 55.9808 89.6287C55.7513 89.8582 55.44 89.9871 55.1154 89.9871H24.1903C23.1199 89.9852 22.0939 89.559 21.3374 88.8017C20.5808 88.0446 20.1555 87.0183 20.1545 85.9479V30.8585C20.1545 29.7257 20.6045 28.6392 21.4056 27.8382C22.2066 27.0371 23.2931 26.5871 24.4259 26.5871H44.4983C45.6302 26.5872 46.7158 27.0365 47.5166 27.8364C47.5167 27.8364 47.5167 27.8365 47.5168 27.8365L58.37 38.6897ZM44.4988 29.0347H44.4983H24.4259C23.9422 29.0347 23.4783 29.2269 23.1363 29.5689C22.7943 29.9109 22.6021 30.3748 22.6021 30.8585V38.4776V38.7776H22.9021H54.2697H54.994L54.4819 38.2655L45.7847 29.5683L45.7846 29.5682C45.4434 29.2274 44.9811 29.0356 44.4988 29.0347Z",
    fill: "#B4B9D6",
    stroke: "#F5F9FF",
    strokeWidth: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_5060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.495 104H65.5046C64.6736 104 64 103.326 64 102.495V71.6863C64 70.8553 64.6736 70.1816 65.5046 70.1816H102.495C103.326 70.1816 104 70.8553 104 71.6863V102.495C104 103.326 103.326 104 102.495 104V104Z",
    fill: "url(#paint0_linear_217_5060)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 71.6861V102.495C104 103.326 103.326 104 102.496 104H97.586L73.353 79.7669V70.1818H102.496C103.326 70.1818 104 70.8555 104 71.6861V71.6861Z",
    fill: "url(#paint1_linear_217_5060)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.495 70.1816H91.9854C92.8163 70.1816 93.49 70.8553 93.49 71.6863V102.495C93.49 103.326 92.8163 104 91.9854 104H102.495C103.326 104 104 103.326 104 102.495V71.6863C104 70.8553 103.326 70.1816 102.495 70.1816Z",
    fill: "url(#paint2_linear_217_5060)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 95.8431V102.495C64 103.326 64.6736 104 65.5046 104H102.495C103.326 104 104 103.326 104 102.495V95.8431H64Z",
    fill: "url(#paint3_linear_217_5060)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8974 80.0246L74.9269 80.0426C75.6032 80.4532 76.4534 80.4463 77.123 80.0247C77.8072 79.6115 78.6641 79.6115 79.3483 80.0247C80.0326 80.4379 80.8894 80.4379 81.5738 80.0247L81.5738 80.0246C81.8909 79.841 82.2418 79.837 82.5952 79.9033C82.9983 79.9789 83.3727 79.6767 83.3727 79.2666V70.4876C83.3727 70.1953 83.1356 69.9583 82.8433 69.9583H73.6275C73.3352 69.9583 73.0981 70.1953 73.0981 70.4876V79.2543C73.0981 79.6619 73.4689 79.967 73.8695 79.892C74.2265 79.8251 74.5806 79.8323 74.8974 80.0246V80.0246Z",
    fill: "url(#paint4_linear_217_5060)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2956 95.0566H69.2586V98.2738C69.2586 98.4022 69.3627 98.5062 69.4911 98.5062H71.2223C71.3507 98.5062 71.4548 98.4021 71.4548 98.2738V95.0566H72.4177C72.7123 95.0566 72.8886 94.7289 72.7264 94.4831L70.6654 91.3604C70.5192 91.139 70.1943 91.139 70.0481 91.3604L67.9871 94.4831C67.8248 94.7289 68.0011 95.0566 68.2956 95.0566V95.0566Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3442 99.6042H67.3689C67.2862 99.6042 67.2192 99.6712 67.2192 99.7539V100.631C67.2192 100.714 67.2862 100.781 67.3689 100.781H73.3442C73.4268 100.781 73.4938 100.714 73.4938 100.631V99.7539C73.4938 99.6712 73.4268 99.6042 73.3442 99.6042Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5882 96.2317H95.6267C95.5441 96.2317 95.4771 96.1647 95.4771 96.0821V95.2048C95.4771 95.1222 95.544 95.0552 95.6267 95.0552H98.5882C98.6708 95.0552 98.7378 95.1222 98.7378 95.2048V96.0821C98.7378 96.1647 98.6708 96.2317 98.5882 96.2317Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.353 98.5063H95.6267C95.5441 98.5063 95.4771 98.4393 95.4771 98.3566V97.4794C95.4771 97.3967 95.544 97.3297 95.6267 97.3297H102.353C102.436 97.3297 102.503 97.3967 102.503 97.4794V98.3566C102.503 98.4393 102.436 98.5063 102.353 98.5063Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.314 100.781H95.6267C95.5441 100.781 95.4771 100.714 95.4771 100.631V99.7539C95.4771 99.6712 95.544 99.6042 95.6267 99.6042H100.314C100.396 99.6042 100.463 99.6712 100.463 99.7539V100.631C100.463 100.714 100.396 100.781 100.314 100.781Z",
    fill: "#C4573A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_5060",
    x1: 70.7191,
    y1: 73.81,
    x2: 102.654,
    y2: 105.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_217_5060",
    x1: 101.29,
    y1: 87.8079,
    x2: 60.1137,
    y2: 58.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_217_5060",
    x1: 105.329,
    y1: 78.9009,
    x2: 80.1348,
    y2: 105.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_217_5060",
    x1: 84,
    y1: 98.3529,
    x2: 84,
    y2: 105.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_217_5060",
    x1: 74.4144,
    y1: 71.0746,
    x2: 85.7913,
    y2: 82.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    stopColor: "#DCE8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7423,
    stopColor: "#B8C4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2AEE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_5060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(64 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.7306b300bdf504311fedbff45b7b6812.svg";
export { ForwardRef as ReactComponent };